import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import { ReservationGuests } from "../../common/SetupMasterEnum";
import FormTextField from "../../components/general/FormTextField";
import {
  deleteRow,
  resetState,
  setFormFieldValue,
  setInitialState,
  setSearchFieldValue,
  submitForm,
} from "../../redux/actions/basicFormAction";
import { UPDATE_FORM_FIELD } from "../../redux/reduxConstants";

const initialFormValues = {
  SetupMasterId: ReservationGuests,
  ParentId: null,
  SetupDetailName: "",
  Flex1: "",
  Flex2: "",
  Flex3: "",
  SetupDetailId: null,
};

const initialSearchValues = {
  SetupMasterId: ReservationGuests,
  ParentId: null,
  SetupDetailName: "",
  Flex1: "",
  Flex2: "",
  Flex3: "",
  SetupDetailId: null,
};
const columns = [
  {
    title: "Reservation Guest Type",
    dataIndex: "SetupDetailName",
    key: "SetupDetailName",
  },
];
const ReservationGuest = () => {
  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);

  const [updateId, setUpdateId] = useState(null);

  const { formFields, searchFields, itemList, formLoading, tableLoading } =
    useSelector((state) => state.basicFormReducer);

  useEffect(() => {
    dispatch(
      setInitialState(
        "/CrudMasterDetail",
        {
          SetupMasterId: ReservationGuests,
          ParentId: null,
          SetupDetailName: "",
          Flex1: "",
          Flex2: "",
          Flex3: "",
          SetupDetailId: null,
        },
        initialFormValues,
        initialSearchValues,
        controller,
        userData
      )
    );

    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);

  useEffect(() => {
    if (updateId !== null) {
      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: itemList.filter((item) => item.SetupDetailId === updateId)[0],
      });
    }
    setUpdateId(null);
  }, [updateId]);

  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleFormChange = (data) => {
    dispatch(setFormFieldValue(data));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      setInitialState(
        "/CrudMasterDetail",
        searchFields,
        initialFormValues,
        searchFields,
        controller,
        userData
      )
    );
  };

  const handleDeleteRow = (id) => {
    dispatch(
      deleteRow(
        "/CrudMasterDetail",
        { SetupDetailId: id, SetupMasterId: ReservationGuests },
        controller,
        userData
      )
    );
  };

  const handleFormSubmit = (e, id, _, closeForm) => {
    e.preventDefault();
    dispatch(
      submitForm(
        "/CrudMasterDetail",
        formFields,
        initialFormValues,
        controller,
        userData,
        id
      )
    );
    closeForm();
  };

  const searchPanel = (
    <Fragment>
      <FormTextField
        colSpan={8}
        label="Reservation Guest Type"
        name="SetupDetailName"
        size={INPUT_SIZE}
        value={searchFields.SetupDetailName}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  const formPanel = (
    <Fragment>
      <FormTextField
        colSpan={8}
        label="Reservation Guest Type"
        name="SetupDetailName"
        size={INPUT_SIZE}
        value={formFields.SetupDetailName}
        onChange={handleFormChange}
        required={true}
      />
    </Fragment>
  );

  return (
    <BasicFormComponent
      formTitle="ReservationGuest"
      searchPanel={searchPanel}
      formPanel={formPanel}
      searchSubmit={handleSearchSubmit}
      onFormSave={handleFormSubmit}
      tableRows={itemList}
      tableLoading={tableLoading}
      formLoading={formLoading}
      tableColumn={columns}
      deleteRow={handleDeleteRow}
      actionID="SetupDetailId"
      editRow={setUpdateId}
      fields={initialFormValues}
    />
  );
};

export default ReservationGuest;
